const ACCESS_TOKEN_KEY = 'propmanAuthToken';
const REFRESH_TOKEN_KEY = 'propmanRefreshToken';
const USER_KEY = 'propmanUser';
const SESSION_EVENT = 'propman-auth-changed';

function safeWindow() {
  return typeof window !== 'undefined' ? window : undefined;
}

function emitSessionChange(detail) {
  const win = safeWindow();
  if (!win) return;

  win.dispatchEvent(
    new CustomEvent(SESSION_EVENT, {
      detail,
    })
  );
}

export function getIdToken() {
  const win = safeWindow();
  if (!win) return null;
  return win.localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  const win = safeWindow();
  if (!win) return null;
  return win.localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getStoredUser() {
  const win = safeWindow();
  if (!win) return null;

  const raw = win.localStorage.getItem(USER_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function storeSession({ idToken, refreshToken, user }) {
  const win = safeWindow();
  if (!win) return;

  if (idToken) {
    win.localStorage.setItem(ACCESS_TOKEN_KEY, idToken);
  }
  if (refreshToken) {
    win.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
  if (user) {
    win.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  emitSessionChange({ idToken, refreshToken, user });
}

export function updateTokens({ idToken, refreshToken }) {
  storeSession({
    idToken: idToken || getIdToken(),
    refreshToken: refreshToken || getRefreshToken(),
    user: getStoredUser(),
  });
}

export function clearSession() {
  const win = safeWindow();
  if (!win) return;

  win.localStorage.removeItem(ACCESS_TOKEN_KEY);
  win.localStorage.removeItem(REFRESH_TOKEN_KEY);
  win.localStorage.removeItem(USER_KEY);

  emitSessionChange({ idToken: null, refreshToken: null, user: null, cleared: true });
}

export function subscribeToSession(listener) {
  const win = safeWindow();
  if (!win) return () => {};

  const handler = (event) => {
    listener(event.detail || {});
  };

  win.addEventListener(SESSION_EVENT, handler);
  return () => {
    win.removeEventListener(SESSION_EVENT, handler);
  };
}

